import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

// Повернення зі Stripe Checkout після скасування. Статична сторінка, без поллінгу/сайд-ефектів.
export default function BillingCancelPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl p-8 border border-black/5 text-center">
        <div className="w-16 h-16 rounded-2xl bg-black/5 flex items-center justify-center mx-auto mb-4">
          <X className="w-8 h-8 text-black/40" strokeWidth={2} />
        </div>
        <h1 className="text-2xl font-bold mb-1">{t("billing.cancel.title")}</h1>
        <p className="text-black/60 mb-6">{t("billing.cancel.subtitle")}</p>
        <button
          onClick={() => navigate("/subscription")}
          className="w-full bg-[#7B9E7F] text-white font-semibold py-4 rounded-2xl"
        >
          {t("billing.cancel.back")}
        </button>
        <button
          onClick={() => navigate("/")}
          className="w-full text-black/50 font-medium py-3 mt-2"
        >
          {t("billing.cancel.home")}
        </button>
      </div>
    </div>
  );
}
